import * as Sentry from "@sentry/vue"
import router from "@/router"
import { Vue } from "@sentry/vue/build/types/types"

export function initSentry(app: Vue | Vue[] | undefined) {
  // Preserve the existing client and any active replay if initialization is repeated.
  if (import.meta.env.VITE_SENTRY_DSN && !Sentry.getClient()) {
    try {
      Sentry.init({
        app,
        dsn: import.meta.env.VITE_SENTRY_DSN,
        release: import.meta.env.VITE_RELEASE,
        trackComponents: true,
        integrations: [
          Sentry.browserTracingIntegration({ router }),
          Sentry.replayIntegration({
            // The replay store resumes only sessions explicitly started in this tab.
            stickySession: true,
            // Bug reports can be stopped immediately; the SDK otherwise drops
            // recordings shorter than five seconds while feedback still sends.
            minReplayDuration: 0,
            maskAllText: false,
            maskAllInputs: false,
            blockAllMedia: false,
            networkDetailAllowUrls: [import.meta.env.VITE_BACKEND_ROOT],
            networkCaptureBodies: true,
          }),
        ],
        replaysSessionSampleRate: 0,
        replaysOnErrorSampleRate: 0,
        tracePropagationTargets: [window.location.host, /^\//],
        tracesSampleRate: 0.01,
      })
    } catch (error) {
      // Optional diagnostics must not prevent the application from loading.
      console.error("Sentry initialization failed", error)
    }
  }
}

export function setUserInSentry(userId: number) {
  Sentry.setUser({ id: `${userId}` })
}

export function clearStoredReplaySession() {
  // SDK 8.28 clears this key only after stop's final upload. A fresh manual
  // recording must not reuse a stopped session left by a reload during upload.
  try {
    sessionStorage.removeItem("sentryReplaySession")
  } catch {
    // As in the SDK, unavailable browser storage must not prevent manual recording.
  }
}
